import { Link } from 'react-router-dom';
import { ArrowUpRight, Menu } from 'lucide-react';
import Logo from '@/components/Logo';
import { DocsSearchField, DocsSearchSheetButton } from './DocsSearch';
import { DOCS_PATH } from '@/data/docs/meta';

interface Props {
  /** Кнопка разделов для телефона и планшета; на главной документации её нет. */
  onOpenNav?: () => void;
  /** На главной документации поиск стоит в первом экране, в шапке он не нужен. */
  search?: boolean;
}

export default function DocsHeader({ onOpenNav, search = true }: Props) {
  return (
    <header className="sticky top-0 z-40 border-b border-ink/[0.08] bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-[90rem] items-center gap-2 px-3 sm:gap-3 sm:px-6 lg:px-8">
        {onOpenNav && (
          <button
            type="button"
            onClick={onOpenNav}
            aria-label="Разделы документации"
            className="grid h-10 w-10 shrink-0 place-items-center rounded-xl text-ink/75 transition-colors hover:bg-ink/5 hover:text-ink lg:hidden"
          >
            <Menu size={20} strokeWidth={1.8} />
          </button>
        )}
        <Link to="/" aria-label="Resstro, на главную" className="shrink-0">
          <Logo className="!h-7" />
        </Link>
        <span aria-hidden className="mx-0.5 h-5 w-px shrink-0 bg-ink/15" />
        <Link
          to={DOCS_PATH}
          className="truncate text-[15px] font-medium text-ink transition-colors hover:text-ink/70"
        >
          Документация
        </Link>

        <div className="ml-auto flex items-center gap-1.5 sm:gap-2">
          {search && (
            <>
              <div className="hidden w-64 md:block lg:w-80">
                <DocsSearchField variant="header" />
              </div>
              <DocsSearchSheetButton />
            </>
          )}
          <Link
            to="/support"
            className="hidden rounded-xl px-3 py-2 text-[14px] font-medium text-ink/70 transition-colors hover:bg-ink/[0.04] hover:text-ink lg:inline-flex"
          >
            Поддержка
          </Link>
          <a
            href="https://admin.resstro.ru"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-dark hidden h-10 gap-2 px-4 py-0 text-[14px] sm:inline-flex"
          >
            Админ-панель
            <ArrowUpRight size={15} strokeWidth={2} />
          </a>
        </div>
      </div>
    </header>
  );
}
